import { type ImageProps } from '@/components/atoms/image/image';

type TeaserCardImageSrcSet = NonNullable<ImageProps['srcSet']>;

const TEASER_CARD_IMAGE_SRCSET_BY_ITEMS: Record<
  2 | 3 | 4,
  TeaserCardImageSrcSet
> = {
  2: {
    desktop: {
      width: 500,
    },
    laptop: {
      width: 450,
    },
    mobile: {
      width: 280,
    },
    tablet: {
      width: 440,
    },
  },
  3: {
    desktop: {
      width: 400,
    },
    laptop: {
      width: 350,
    },
    mobile: {
      width: 280,
    },
    tablet: {
      width: 600,
    },
  },
  4: {
    desktop: {
      width: 300,
    },
    laptop: {
      width: 250,
    },
    mobile: {
      width: 250,
    },
    tablet: {
      width: 400,
    },
  },
};

const DEFAULT_TEASER_CARD_IMAGE_SRCSET: TeaserCardImageSrcSet = {
  desktop: {
    width: 720,
  },
  laptop: {
    width: 656,
  },
  mobile: {
    width: 280,
  },
  tablet: {
    width: 440,
  },
};

export const getTeaserCardImageConfig = (itemsInRow?: number) => {
  if (itemsInRow === 2 || itemsInRow === 3 || itemsInRow === 4) {
    const srcSet = TEASER_CARD_IMAGE_SRCSET_BY_ITEMS[itemsInRow];

    return {
      srcSet,
      width: srcSet.desktop?.width ?? 720,
    };
  }

  return {
    srcSet: DEFAULT_TEASER_CARD_IMAGE_SRCSET,
    width: DEFAULT_TEASER_CARD_IMAGE_SRCSET.desktop?.width ?? 720,
  };
};
